import React from "react";
import { getMorPduReadingsRackWise } from "../../../services/infrastructure-automation/InfrastructureAutmationService";
import { ToastContext } from "../../common/ToastProvider";
import { Loading } from "../../../services/Loading";
import { Stack } from "@fluentui/react";
import { toFixedValue } from "../../../services/UtilService";
import moment from "moment";

export interface RackwiseReadingsProps {
  searchObj: any;
}

const RackwiseReadings: React.FC<RackwiseReadingsProps> = ({ searchObj }) => {
  // hooks
  const { showToast } = React.useContext(ToastContext);
  // state
  const [isLoading, setLoading] = React.useState(false);
  const [rackWiseReadings, setRackWiseReadings] = React.useState([] as any[]);

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await searchMorReadingsRackWise();
    };
    asyncFunc();
  }, [searchObj]);

  const searchMorReadingsRackWise = async (floorId?: string) => {
    setLoading(true);
    const serchObj = { ...searchObj };
    if (floorId) {
      serchObj["floorId"] = floorId;
    }
    serchObj.startDate = moment(searchObj.startDate).format("YYYY-MM-DD");
    serchObj.endDate = moment(searchObj.endDate).format("YYYY-MM-DD");
    // serchObj.startDate = moment(state.date).startOf("month").toDate();
    // serchObj.endDate = moment(state.date).endOf("month").toDate();
    const result = await getMorPduReadingsRackWise(serchObj);
    if (result && result.success) {
      setRackWiseReadings(result.data);
      setLoading(false);
    } else {
      setLoading(false);
      showToast(
        result.message || "Error while fetching sensors readings",
        "error"
      );
    }
  };

  return (
    <React.Fragment>
      {isLoading && <Loading />}
      <Stack>
        <Stack.Item className="max-table-width">
          <div className="office-table bg-white">
            <table className="ms-Table bordered-table w-100">
              <thead className="html-table-thead" style={{ fontSize: 14 }}>
                <tr style={{ height: 44 }}>
                  <th>Customer Name</th>
                  <th>Rack No</th>
                  <th>Pdu No</th>
                  <th>Breaker No</th>
                  <th>kw</th>
                  <th>Amps</th>
                  <th>kwh</th>
                  {/* <th>Actions</th> */}
                </tr>
              </thead>
              <tbody>
                {rackWiseReadings && rackWiseReadings.length > 0 ? (
                  rackWiseReadings.reduce((acc: any, d, rIndex) => {
                    d.pduReadings.forEach((p: any, index: number) => {
                      acc.push(
                        <tr key={rIndex + "" + index}>
                          {index === 0 && (
                            <td rowSpan={d.pduReadings.length}>
                              {d.customerName}
                            </td>
                          )}
                          {index === 0 && (
                            <td rowSpan={d.pduReadings.length}>
                              {d.quadrantName + "-" + d.rackNo}
                            </td>
                          )}
                          {index === 0 && (
                            <td rowSpan={d.pduReadings.length}>
                              {p.pduName.join(", ")}
                            </td>
                          )}
                          {/* <td>{d.customerName}</td>
                          <td>{d.quadrantName + "-" + d.rackNo}</td>
                          <td>{p.pduName.join(", ")}</td> */}
                          <td>{p.phaseName}</td>
                          <td>{toFixedValue(p.kw)}</td>
                          <td>{toFixedValue(p.amps)}</td>
                          <td>{toFixedValue(p.kwh)}</td>
                          {/* <td>Actions</td> */}
                        </tr>
                      );
                    });
                    console.log("c-rack", acc);
                    return acc;
                  }, [])
                ) : (
                  <tr>
                    <td colSpan={7} align="center">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </Stack.Item>
      </Stack>
    </React.Fragment>
  );
};

export default RackwiseReadings;
